// src/utilities/no-inner-events-component.ts
import { LitElement } from "lit";
var NoInnerEventsComponent = class extends LitElement {
  constructor() {
    super(...arguments);
    this.stopInnerSlotEvents = (event) => event.stopPropagation();
    this.customEvents = [];
  }
  connectedCallback() {
    super.connectedCallback();
    this.customEvents.forEach((eventName) => {
      this.shadowRoot.addEventListener(eventName, this.stopInnerSlotEvents);
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.customEvents.forEach((eventName) => {
      this.shadowRoot.removeEventListener(eventName, this.stopInnerSlotEvents);
    });
  }
};

export {
  NoInnerEventsComponent
};
